const calculateMinHeight = (
	showMobileHeaderLocationBar: boolean | null | undefined,
	baseXs: string,
	baseMd: string,
	additionalXs?: string,
	additionalMd?: string
) => {
	const xsBase = showMobileHeaderLocationBar ? baseXs : '4rem';
	return {
		xs: additionalXs ? `calc(${xsBase} + ${additionalXs})` : xsBase,
		md: additionalMd ? `calc(${baseMd} + ${additionalMd})` : baseMd,
	};
};

export const getMinHeaderHeightStyles = (
	showMobileHeaderLocationBar?: boolean | null,
	isWithNavMenu?: boolean,
	showHeaderWithLocationNav?: boolean,
	showTopAlertBannerMessages?: boolean,
	showBottomAlertBannerMessages?: boolean
) => {
	if (isWithNavMenu) {
		const baseXs = '6rem';
		const baseMd = '8.5rem';

		if (showTopAlertBannerMessages && showBottomAlertBannerMessages) {
			return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, baseXs, baseMd, '5.5rem', '6rem') };
		}

		if (showTopAlertBannerMessages || showBottomAlertBannerMessages) {
			return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, baseXs, baseMd, '2.75rem', '3rem') };
		}

		return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, baseXs, baseMd) };
	}

	if (showHeaderWithLocationNav) {
		return { minHeight: { xs: '7.25rem', md: '8.75rem' } };
	}

	return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, '6rem', '6.875rem') };
};

export const getHeaderWrapperStyles = (
	showMobileHeaderLocationBar?: boolean | null,
	isWithNavMenu?: boolean,
	showHeaderWithLocationNav?: boolean,
	showTopAlertBannerMessages?: boolean,
	showBottomAlertBannerMessages?: boolean
) => ({
	width: '100vw',
	...getMinHeaderHeightStyles(showMobileHeaderLocationBar, isWithNavMenu, showHeaderWithLocationNav, showTopAlertBannerMessages, showBottomAlertBannerMessages),
	backgroundColor: 'backgrounds.white',
});
